import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useForm } from './FormManager';
import './SummerOfferBanner.css';

const SummerOfferBanner = () => {
  const { t } = useTranslation();
  const { openSummerForm } = useForm();
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  
  // Handle scroll to hide banner on mobile
  useEffect(() => {
    const handleScroll = () => {
      // Only hide on mobile devices
      if (window.innerWidth <= 768) {
        const currentScrollY = window.scrollY;
        
        // Hide when scrolling down, show when at top
        if (currentScrollY > 50) {
          setIsVisible(false);
        } else {
          setIsVisible(true);
        }
        
        setLastScrollY(currentScrollY);
      }
    };
    
    window.addEventListener('scroll', handleScroll, { passive: true });
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [lastScrollY]);
  
  // Dispatch custom event when visibility changes
  useEffect(() => {
    // Add banner-hidden class to body when banner is hidden
    if (!isVisible) {
      document.body.classList.add('banner-hidden-body');
    } else {
      document.body.classList.remove('banner-hidden-body');
    }
  }, [isVisible]);
  
  return (
    <div 
      className={`summer-offer-banner ${!isVisible ? 'banner-hidden' : ''}`} 
      onClick={openSummerForm} 
      style={{ cursor: 'pointer' }}
    >
      <div className="summer-offer-content">
        <div className="summer-offer-title">{t('summerOfferTitle')}</div>
        <div className="summer-offer-text">{t('summerOfferText')}</div>
      </div>
      <div className="summer-offer-shine"></div>
    </div>
  );
};

export default SummerOfferBanner;
